import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import data from "../data/data";
import { useParams } from "react-router";
import { SubscriptionApi } from "../api-services/subscription";


export default function Subscription() 
{
  const { id } = useParams();
  const subscript = SubscriptionApi();

  const selectedPlan = data?.pricing.find((plan) => plan.id === id);
  const subscription = data?.subscription.find((plan) => plan.id === id) || { offers: [] } ;

  const [state, setState] = useState(false);

  const [inputs, setInputs] = useState({
      fname: "", lname: "",  phone:"", duration: subscription.offers[0]?.duration, price: subscription.offers[0]?.price, operator: "", planIndex: id, type: selectedPlan?.title
  });
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputs = (event) => {
      const { name, value } = event.target;

      if (name === "duration") {
        const selectedDuration = subscription.offers?.find((p) => p.duration === parseInt(value) );
        if (selectedDuration) {
          setInputs((prev) => ({
            ...prev,
            duration: value,
            price: selectedDuration.price,
          }));
        }
      }
      else {
        setInputs((prev) => ({ ...prev, [name]: value }));
      }
  };
     
  const handleForm = async ( event ) => {
      event.preventDefault();
      // console.log(inputs);
        
      const userId = localStorage.getItem("uid")
      setIsLoading(true);
      setStatus(0);

      try {
          const res = await subscript.insert(userId, inputs);
          setIsLoading(false);
          (res.data.success) ? setStatus(1) : setStatus(-1);  
      } catch (err) { 
          setIsLoading(false);
          setStatus(-1); 
      }
  } 

  return (
    <div className="bg-light min-vh-100">
      {/* Header's section */}
      <Header page={3} />

      {/* Bandeau promo */}
      <div className="container py-5 mt-2">
        <div className="rounded-4 p-5 position-relative overflow-hidden" style={{background:"linear-gradient(90deg, #1e1f1eff 0%, #347944ff 100%)"}}>
          <div className="row g-3 align-items-center">
            <div className="col d-flex align-items-center gap-3">
              <div className="fs-1 text-light">
                  <img src="../favicon-light.png" alt="icon-agrospace" width="60" className="me-2"/>
              </div>
              <div className="text-white fs-3 ">
                 Abonnement de service premium d'Agrospace
              </div>
            </div>
          </div>
        </div>
      </div>

       {/* Contenu */}
      <div className="container pb-5">

        <form className="row justify-content-between" onSubmit={handleForm} >
          {/* Colonne gauche */}
          <div className="col-lg-6 mb-4">

            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-body p-5">
                <p className="fs-5 border-bottom w-100 pb-3 text-muted rounded-2 mb-4 px-2"> Modalité de l'abonnement </p>

                {/* Type */}
                <div className="mb-3">
                  <label className="form-label text-muted small">Abonnement choisi</label>
                  <div className="d-flex gap-2 mb-2" >
                    <input type="text" name="type" value={ selectedPlan?.title } placeholder="Premium simple" className="w-100 border input py-3 px-3 text-muted rounded-2" required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* Durée */}
                <div className="mb-3">
                  <label className="form-label text-muted small">Durée de l'abonnement</label>
                  <div className="d-flex gap-2 mb-2" >
                    <select className="w-100 border input py-3 px-3 text-muted rounded-2" name='duration' value={inputs.duration} onChange={handleInputs} required >
                      <option value="" > Choisir la durée d'abonnement </option>
                      {
                        subscription.offers?.map( (item, index)=>(
                          <option value={item.duration} key={index}> {item.duration} mois</option>
                        ) )
                      }
                    </select>
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>  
                </div>

                <div className="d-flex flex-column py-3 border-top border-bottom">
                  <span className="text-muted mb-2"> Bonus </span>
                  <span className="alert alert-success p-2 small"> +1 mois offert à partir de 12 mois </span>
                </div>

                <div className="d-flex justify-content-between align-items-center py-2 mt-2">
                  <div className="lead"> Montant à payer </div>
                  <div className="d-flex gap-2 mb-2" >
                    <span className="d-flex align-items-center border w-100 py-3 px-5 text-muted rounded-2"> { inputs?.price } </span> 
                    <span className="d-flex align-items-center border p-3 rounded-2 text-muted"> Fcfa </span> 
                  </div>
                </div>
                
                <div>
                    <button type="submit" className="btn btn-outline-success mt-2" onClick={ ()=> setState(true) }> 
                        Suivant <i className="bi bi-arrow-right ms-2"></i>
                    </button>
                </div>

              </div>
            </div>
          </div>
          
           
          {/* Colonne droite */}
          <div className="col-lg-5 mb-5">

            <div className="d-flex flex-column mb-3 border rounded-2 p-4 shadow-sm bg-green-light mb-4">
              <div className="fs-4 text-success me-2">
                <i className="bi bi-plus-circle"></i>
              </div>
              <p className="text-muted" >Assurer vous que le montant à débiter soit bien disponible dans le compte que vous aurez fourni selon l'opérateur mobile</p>
              <a href="/tarifs" className="text-success cursor-pointer nav-link">
                  Voir toutes les offres freemium <i className="bi bi-arrow-right ms-2"></i>
              </a>
            </div>

            {
              isLoading && (
                <div className="d-flex justify-content-center align-items-center mb-3"> 
                  <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                </div>
              )
            }
            {
              status === 1 && (
                <div className="col-md-12 mb-2">
                  <div className="alert alert-success">
                    Payment effectué avec succes. Vous etes maitenant abonné à notre version { inputs?.type } 
                  </div>
                </div>
              )
            }
            {
              status === -1 && (
                <div className="col-md-12 mb-2">
                  <div className="alert alert-danger">
                    Erreur !!. Assurer vous que le montant à payer soit disponible dans votre compte puis rééssayer.
                  </div>
                </div>
              )
            }
            {
              (!selectedPlan) && ( <div className="alert alert-danger text-muted p-3">  Ce tarif n'existe pas. Vueillez verifier  </div> )
            }
            {
              state && (

            <div className="card border-0 shadow-sm rounded-4 p-5">
                <p className="fs-5 border-bottom w-100 p-3 text-muted rounded-2 mb-4 bg-green-light"> Informations de payement </p>

                {/* Name */}
                <div className="mb-3">
                  <label className="form-label text-muted small">Prénom </label>
                  <div className="d-flex gap-2 mb-2" >
                    <input type="text" name="fname" placeholder="Prenom et nom de l'hote" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={handleInputs} required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* Name */}
                <div className="mb-3">
                  <label className="form-label text-muted small">Nom </label>
                  <div className="d-flex gap-2 mb-2" >
                    <input type="text" name="lname" placeholder="Prenom et nom de l'hote" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={handleInputs} required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* Type */}
                <div className="mb-2">
                  <label className="form-label text-muted small">Numéro de téléphone</label>
                  <div className="d-flex gap-2 mb-2" >
                    <input type="text" name="phone" placeholder="" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={handleInputs} required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2 mt-2">
                  <div className="fs-5">Montant total </div>
                  <div className="d-flex gap-2 mb-2" >
                    <span className="d-flex align-items-center border w-100 py-3 px-5 text-muted rounded-2 bg-green-light"> { inputs?.price } </span> 
                    <span className="d-flex align-items-center border p-3 rounded-2 text-muted"> Fcfa </span> 
                  </div>
                </div>
                <div className="my-3 text-muted text-center">──────── Choisir opérateur de paiement ────────</div>
                <div className= "d-flex mb-4 mt-2">
                    <span
                      className={`cursor w-100 py-2 px-3 font-semibold text-muted border ${inputs?.operator === 'wave' ? 'bg-green-light' : 'bg-white'}`}
                      onClick={ () =>setInputs((prev) => ({ ...prev, "operator": "wave" })) }
                    >
                      Wave
                    </span>
                    <span
                      className={`cursor w-100 py-2 px-3 font-semibold text-muted border ${inputs?.operator === 'orange-money' ? 'bg-green-light' : 'bg-white'}`}
                      onClick={ () =>setInputs((prev) => ({ ...prev, "operator": "orange-money" }))}
                    >
                      Orange money
                    </span>
                  </div>

                <button type="submit" className="btn btn-lg btn-success mt-2"> 
                    Payer maintenant 
                </button>
            </div>
            )}
          </div>

        </form>
      </div>
              
               
               

      {/* Footer's section */}
      <Footer />
      
    </div>
  );
}
